<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-lifebuoy"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
    <path d="M15 15l3.35 3.35"></path>
    <path d="M9 15l-3.35 3.35"></path>
    <path d="M5.65 5.65l3.35 3.35"></path>
    <path d="M18.35 5.65l-3.35 3.35"></path>
  </svg>
</template>

<script lang="ts" setup>
export interface IconProps {
  width?: string;
  height?: string;
}

withDefaults(defineProps<IconProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
